import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Link, useNavigate } from "react-router-dom";

export default function BasicInfo() {
  const [postCode, setPostCode] = useState("");
  const [postCodeErr, setPostCodeErr] = useState("");

  const [firstName, setFirstName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameErr, setLastNameErr] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState();
  const [dateOfBirthErr, setDateOfBirthErr] = useState("");
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user, dispatch } = useAuthContext();
  const [enableEdit, setEnableEdit] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [stripeAccount,setStripeAccount] = useState(null)
  const navi = useNavigate();
  const [country,setCountry] = useState("")
  

  const dashboardAccess = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${ApiConnectionString}/api/dashboard`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
  
      if (response.status === 200) {
        window.location.href = response.data; // Redirect to the URL in response.data
      }
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);

      const userResponse = await axios.get(
        `${ApiConnectionString}/api/user/myprofile`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      console.log(userResponse.data)


      setDateOfBirth(new Date(userResponse.data.dateOfBirth));
      setFirstName(userResponse.data.firstName);
      setLastName(userResponse.data.lastName);
      setUsername(userResponse.data.username);
      setEmail(userResponse.data.email);
      setPostCode(userResponse.data.postCode);
      setStripeAccount(userResponse.data.stripeAccount)
      setCountry(userResponse.data.country)
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }

      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const nameRegex = /^[A-Za-z\s-']+$/;
  const postcodeRegex =
    /^([A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}|[A-Z]{1,2}\d{2}\s?\d[A-Z]{2})$/i;
  const phoneNumberPattern = /^07\d{9}$/;
  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const isOver18 = (dateOfBirth) => calculateAge(dateOfBirth) >= 18;

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    setFirstNameErr("");
    setPostCodeErr("");
    setDateOfBirthErr("");

    let err = false;

    // FirstName Validations
    if (!nameRegex.test(firstName)) {
      err = true;
      setFirstNameErr(
        "Your first name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (firstName.length < 2) {
      err = true;
      setFirstNameErr(
        "Your first name is too short. It must be at least 2 characters long"
      );
    }
    if (firstName.length > 50) {
      err = true;
      setFirstNameErr(
        "Your first name is too long. It must not be over 50 characters"
      );
    }

    // LastName Validations
    if (!nameRegex.test(lastName)) {
      err = true;
      setLastNameErr(
        "Your last name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (lastName.length < 2) {
      err = true;
      setLastNameErr(
        "Your last name is too short. It must be at least 2 characters long"
      );
    }
    if (lastName.length > 50) {
      err = true;
      setLastNameErr(
        "Your last name is too long. It must not be over 50 characters"
      );
    }

    // DoB Validation
    if (!isOver18(dateOfBirth)) {
      err = true;
      setDateOfBirthErr("You must be at least 18 years old");
    }
    if (!dateOfBirth) {
      err = true;
      setDateOfBirthErr("Date of Birth is required");
    }

    // PostCode Validation
    if (!postcodeRegex.test(postCode)) {
      err = true;
      setPostCodeErr("Postcode must be a valid UK postcode.");
    }

    if (!err) {
      const updateuser = {
        postCode,
        firstName,
        lastName,
        dateOfBirth,
      };

      try {
        const updateAppUserResponse = await axios.put(
          `${ApiConnectionString}/api/user`,
          updateuser,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        if (updateAppUserResponse.status == 200) {
          setComplete(true);
        }
      } catch (error) {
        console.error("Failed to update onboarding application:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    if (enableEdit) {
      if (complete) {
        return (
          <div className="bg-white">
            <div className="lightBlueBanner">
              <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
                Account Updated
              </p>
            </div>
            <p>
              Your updated information has been successfully submitted to our
              system. Please allow some time for us to review and process your
              request before updating your details. Thank you for your patience.
            </p>
          </div>
        );
      } else {
        return (
          <div className="bg-white">
            <div className="lightBlueBanner">
              <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
                Basic Info
              </p>
            </div>
            <p>
              Please note that your email and username cannot be changed. If you
              are having issues with your email or username, please make a{" "}
              <Link to="/helpandsupport">support request</Link> on the Help and
              Support page.
            </p>
            <button
              className="pointer cancelButton fw-bold mb-3 px-3"
              onClick={() => setEnableEdit(false)}
            >
              Cancel Update
            </button>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col">
                  <table>
                    <tbody>
                      <tr>
                        <th>
                          <span>Legal First Names:</span>
                        </th>
                        <td>
                          <input
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                          />
                          {firstNameErr && (
                            <p className="text-danger">{firstNameErr}</p>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <span>Legal Last Name:</span>
                        </th>
                        <td>
                          <input
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                          />
                          {lastNameErr && (
                            <p className="text-danger">{lastNameErr}</p>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th>Date Of Birth:</th>
                        <td>
                          <input
                            type="date"
                            value={dateOfBirth}
                            onChange={(e) => setDateOfBirth(e.target.value)}
                            required
                          />
                          {dateOfBirthErr && (
                            <p className="text-danger">{dateOfBirthErr}</p>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th>{
  country === ""
    ? "Postal Code/ Zip Code"
    : country === "UK"
    ? "Postcode"
    : country === "US"
    ? "ZIP Code"
    : country === "AU"
    ? "Postcode"
    : country === "CA"
    ? "Postal Code"
    : "Postal Code"
}
:</th>
                        <td>
                          <input
                            value={postCode}
                            onChange={(e) => setPostCode(e.target.value)}
                            required
                          />
                        </td>
                      </tr>
                      {postCodeErr && (
                        <p className="text-danger mx-5">{postCodeErr}</p>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button className="saveChanges-button my-4">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        );
      }
    } else {
      return (
        <div className="">
          <div className="lightBlueBanner">
            <p className="text-white p-3 fw-bold ">Basic Info</p>
          </div>

          <table className="table">
            <tbody>
              <tr>
                <th>Username</th>
                <td>{username}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{email}</td>
              </tr>
              <tr>
                <th>First Name</th>
                <td>{firstName}</td>
              </tr>
              <tr>
                <th>Last Name</th>
                <td>{lastName}</td>
              </tr>

              <tr>
                <th> {
  country === ""
    ? "Postal Code/ Zip Code"
    : country === "UK"
    ? "Postcode"
    : country === "US"
    ? "ZIP Code"
    : country === "AU"
    ? "Postcode"
    : country === "CA"
    ? "Postal Code"
    : "Postal Code"
}
</th>
                <td>{postCode}</td>
              </tr>
              <tr>
                <th>Date of Birth</th>
                <td> {new Date(dateOfBirth).toLocaleDateString()}</td>
              </tr>
            </tbody>
          </table>

          <button
            className="saveChanges-button m-2"
            onClick={() => setEnableEdit(true)}
          >
            Update
          </button>
          {stripeAccount && (
  <div>
    <hr />
    <div className="lightBlueBanner">
      <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20">Stripe Account</p>
    </div>
    <p>You can access your express account to view transactions and payouts.</p>
    <button onClick={dashboardAccess} className="saveChanges-button mb-5">
      Go to Stripe Dashboard
    </button>
  </div>
)}
       
        </div>
      );
    }
  }
}
